import { API } from "aws-amplify";
import { REST_API } from "../constants";

export type Log = {
  level: string;
  message: string;
  timestamp: string;
  sessionId?: string;
};

export class LogProxy {
  static path = "/logs";
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static async log(data: any): Promise<void> {
    const log = data as Log;
    try {
      await API.post(REST_API, LogProxy.path, {
        body: log,
      });
    } catch (error) {
      console.error(error);
    }
  }
}
